module.exports = __webpack_public_path__ + "images/31a1cd4da8bcb3be37fecf28309a41a3.png";